import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import ForumApplication from 'flarum/forum/ForumApplication';
import Sidebar from './components/Sidebar';

function initWaifu() {
  if (document.querySelector('script[src*="live2d-widget"]') || document.querySelector('script[src*="autoload.js"]')) return;
  // 随机模型（live2d_api 提供多组模型）
  localStorage.setItem('modelId', String(Math.floor(Math.random() * 7)));
  localStorage.setItem('modelTexturesId', '0');

  // 自托管看板娘（同源，无 CORS）
  const script = document.createElement('script');
  script.src = '/assets/live2d-widget/autoload.js';
  document.body.appendChild(script);
}

app.initializers.add('treasuregrove-moe-green', () => {
  extend(ForumApplication.prototype, 'mount', function () {
    // 主页 hero 横幅：mount 阶段 app.forum 已就绪（initializer 阶段还没加载）
    const bannerUrl = app.forum.attribute('heroBannerUrl');
    if (bannerUrl) {
      document.documentElement.style.setProperty('--hero-banner', `url("${bannerUrl}")`);
    }

    if (!document.querySelector('.MoeSidebar-root')) {
      const container = document.createElement('div');
      container.className = 'MoeSidebar-root';
      document.body.appendChild(container);
      m.mount(container, Sidebar);
    }

    initWaifu();
  });
});
